import RegisterView from "./RegisterView";
export default RegisterView;